module.exports = __webpack_public_path__ + "static/media/06(3).8449fe5f.jpg";